/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import SelectSingleRestExt from './SelectSingleRestExt';
import { platformResellerActions, platformResellerConstants } from '../../modules/platformreseller/actions';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { StoreHelper } from '../../helpers/StoreHelper';

const _ = require('underscore');

class SelectSingleReseller extends Component {
    constructor(props, context) {
        super(props, context);
        StoreHelper.requiresStore(this, 'platformResellerReducers');
    }

    componentDidMount() {
        this.onComponentInit();
    }

    onComponentInit = () => {
        const { dispatch } = this.props;
        dispatch(
            platformResellerActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
                [],
                [{ name: 'mainname', value: 'asc' }],
                platformResellerConstants.PLATFORM_RESSELLER_SELECTED_LIST
            )
        );
    };

    onChangeWrapper = (e) => {
        if (e) {
            this.props.onChange(e.value);
        }
    };

    render() {
        const { resellerList, defaultValue } = this.props;
        let o = null;
        if (resellerList && _.size(resellerList['hydra:member']) !== 0) {
            resellerList['hydra:member'].map((row) => {
                if (row.id === defaultValue) {
                    o = { value: row.id, label: row.mainname };
                }
                return {};
            });
        }
        return (
            <SelectSingleRestExt
                options={resellerList}
                helperText="platform_reseller:select.choose_reseller"
                label="platform_reseller:select.reseller"
                selected={o}
                rest={this.props}
                onChange={this.onChangeWrapper}
            />
        );
    }
}

SelectSingleReseller.propTypes = {
    classes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
    const { platformResellerReducers } = state;
    if (platformResellerReducers === undefined) {
        return {};
    }
    let list = null;
    if (platformResellerReducers && platformResellerReducers.collections) {
        list = platformResellerReducers.collections;
    }
    return {
        type: platformResellerReducers.type,
        resellerList: list,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(SelectSingleReseller);
export default Enhance;
